import React from "react";
import { Box, Typography } from "@mui/material";

// Google Fonts リンクを一度だけ挿入
const FONT_LINK_ID = "admin-title-bar-fonts";
if (typeof document !== "undefined" && !document.getElementById(FONT_LINK_ID)) {
  const link = document.createElement("link");
  link.id = FONT_LINK_ID;
  link.rel = "stylesheet";
  link.href =
    "https://fonts.googleapis.com/css2?family=Orbitron:wght@700;900&display=swap";
  document.head.appendChild(link);
}

const TITLE_BAR_HEIGHT = 48;

export { TITLE_BAR_HEIGHT };

export default function AdminTitleBar() {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: TITLE_BAR_HEIGHT,
        px: 2,
        background: "rgba(255,255,255,0.68)",
        backdropFilter: "blur(18px) saturate(180%)",
        WebkitBackdropFilter: "blur(18px) saturate(180%)",
      }}
    >
      <Typography
        variant="h6"
        sx={{
          userSelect: "none",
          lineHeight: 1.3,
          fontFamily: "'Orbitron', sans-serif",
          fontWeight: 900,
          letterSpacing: 0.5,
          color: "#3aad6a",
          textShadow:
            "0 0 8px rgba(110,230,160,0.5), 0 0 20px rgba(58,173,106,0.3)",
        }}
      >
        MasterMindMembers
      </Typography>
    </Box>
  );
}
